/* Shared helpers for dashboard cards that read the site's Scheduler data
   (ProjectProgressCard, MasterScheduleCard). Both use the same two-step
   query pattern as the Scheduler page, sharing its query cache. */

// The schedule-query retry policy lives in @apis/schedule (next to the error
// classes it checks) so the cards and the TopBar picker share one source.
export { scheduleRetry } from '@apis/schedule';

/**
 * Today as midnight in the PROJECT's zone, matching the 'YYYY-MM-DD' task dates
 * (parsed as UTC). `tz` decides which day "today" is — a site east of the
 * viewer has already rolled over, and the progress headline keys off it.
 */
export function projectTodayMs(tz: string): number {
  const ymd = new Intl.DateTimeFormat('en-CA', { timeZone: tz }).format(new Date());
  return Date.parse(ymd);
}
